import {NavigableIndicatorChart} from "./NavigableIndicatorChart";
import * as $ from "jquery";

/**
 * A container for a precipitation chart
 * @extends NavigableIndicatorChart
 * @hideconstructor
 */
class PrecipitationChart extends NavigableIndicatorChart {

    getClassName() {
        return "PrecipitationChart";
    }

    setUntilAndCoords(until,wgs84Coords, dataFromService) {
        this.dataFromService = dataFromService;
        super.setUntilAndCoords(until,wgs84Coords, false);
        this._updateChart();
    }

    _updateChart() {
        this.chartData = this._extractChartData();
        super._updateChart();
    }

    getStatsSeriesName(isAccumulated=false) {
        return this.translator.translate(isAccumulated ? 'tool.charts.precipitation.statsSeriesAccumulatedName' : 'tool.charts.precipitation.statsSeriesName');
    }

    _addMainLegend() {
        const body = $('.container .body', this.uiElement);
        const smallGraphic = this.layer.getChartLegend() ? this.layer.getChartLegend().getChartGraphic() : undefined;
        if (smallGraphic && smallGraphic.length > 0) {
            smallGraphic.click(() => this.layer.showInfo(this.infoModal)).css('cursor', 'pointer');
            $('.container .body .chart-container.values', this.uiElement).append(smallGraphic);
        }
        body.removeClass('has-legend');
        $(body.children('.legend-container')[0]).remove();
    }

    _initDatePicker() {
        if(!this.dataFromService.features[0].properties.rain.values)
            return;
        super._initDatePicker();
    }
}

export {PrecipitationChart}